import Policymodel from './Policymodel.vue';
export default Policymodel;
